import { handleActions } from 'redux-actions';
import { createSelector } from 'reselect';
import AccountsType from '../types/AccountsType';
import { GridFilters, initialStateList } from './GridFiltersReducer';

const initialState = {
  allAccounts: { ...initialStateList },
  accountDetails: {},
  roles: [],
  capabilities: [],
  presets: [],
  mailGroups: [],
};
export const Accounts = handleActions(
  {
    ...GridFilters,
    [AccountsType.actions.fetchAccountDetailsSuccess]: (state, { payload: { accountDetails } }) => {
      return {
        ...state,
        accountDetails,
      };
    },
    [AccountsType.actions.fetchRolesSuccess]: (currentState, { payload }) => ({ ...currentState, roles: payload }),
    [AccountsType.actions.fetchCapabilitiesSuccess]: (currentState, { payload }) => ({ ...currentState, capabilities: payload }),
    [AccountsType.actions.fetchPresetsSuccess]: (currentState, { payload }) => ({ ...currentState, presets: payload }),
    [AccountsType.actions.fetchMailGroupsSuccess]: (currentState, { payload }) => ({ ...currentState, mailGroups: payload }),
  },
  initialState
);

const getAccounts = (state) => state.Accounts;
export const getAccountDetails = (state) => state.Accounts.accountDetails;

export const getAccountsList = (state, list) => {
  const accounts = getAccounts(state);
  return accounts[list] || undefined;
};

export const getRoles = createSelector(getAccounts, (accounts) => accounts.roles);

export const getAllCapabilities = createSelector(getAccounts, (accounts) => accounts.capabilities);

export const getAllPresets = createSelector(getAccounts, (accounts) => accounts.presets);

export const getMailGroups = createSelector(getAccounts, (accounts) => accounts.mailGroups);
